import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ScrollToTop } from './components/ScrollToTop';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
// Pages
import { Home } from './pages/Home';
import { WhatWeDo } from './pages/WhatWeDo';
import { Platform } from './pages/Platform';
import { UseCasesPage } from './pages/UseCasesPage';
import { WhySureAI } from './pages/WhySureAI';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
export function App() {
  return <Router data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="min-h-screen bg-sure-black flex flex-col font-mono selection:bg-sure-accent selection:text-sure-black" data-id="element-2">
        <Navbar data-id="element-3" />
        <main className="flex-grow flex flex-col" data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<Home data-id="element-7" />} data-id="element-6" />
            <Route path="/what-we-do" element={<WhatWeDo data-id="element-9" />} data-id="element-8" />
            <Route path="/platform" element={<Platform data-id="element-11" />} data-id="element-10" />
            <Route path="/use-cases" element={<UseCasesPage data-id="element-13" />} data-id="element-12" />
            <Route path="/why-sure-ai" element={<WhySureAI data-id="element-15" />} data-id="element-14" />
            <Route path="/about" element={<About data-id="element-17" />} data-id="element-16" />
            <Route path="/contact" element={<Contact data-id="element-19" />} data-id="element-18" />
          </Routes>
        </main>
        <Footer data-id="element-20" />
      </div>
    </Router>;
}